import React, {ErrorInfo} from "react"
import {analyticsEvent} from "../utils/google-analytics"
import { ErrorBoundary as SentryErrorBoundary } from "@sentry/react"


/**
 * Component to throw a rendering error.
 * For the purpose of testing <ErrorBoundary>...</ErrorBoundary>
 */
const checkEnabled = true
export function ErrorBoundaryChecker() {
    if (checkEnabled) throw new Error("Test rendering error")
    return <div>Won't ever render</div>
}

export class ErrorBoundary extends SentryErrorBoundary {
    componentDidCatch(error: unknown, errorInfo: ErrorInfo) {
        super.componentDidCatch(error, errorInfo)
        analyticsEvent("error_boundary")
        console.error(error)
    }
}